import { memo } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSection } from 'ui/components'

export const HistorySection = memo(() => {
  const routeApi = getRouteApi('/_app/documents/$documentId')
  const navigate = routeApi.useNavigate()
  const search = routeApi.useSearch()

  const { history, historyTotalCount } = routeApi.useLoaderData()

  if (!history) return null

  return (
    <PageSection title="Document History">
      <Layer rounded shadowed>
        <HistoryTable
          dataQa={TableDataQa.BP_DOCUMENT_HISTORY}
          items={history}
          loading={false}
          pagination={{
            page: search?.historyPage || 1,
            size: search?.historySize || 10,
            onChange: (historyPage, historySize) =>
              navigate({
                to: '/documents/$documentId',
                resetScroll: false,
                replace: true,
                search: { historyPage, historySize }
              }),
            total: historyTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
})
